import styled from 'styled-components';

import { ThemeProps as Prop, Components } from '@powdr/constants';
import { themeUtil } from '@powdr/utils';

const CPNT = Components.HOTSPOT_GROUP;

export const StyledHotspotGroup = styled.div`
  scroll-margin-top: ${({ $scrollMargin }) => `${$scrollMargin}px`};
`;

export const HotspotImageSelectors = styled.ul`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;

export const HotspotImageSelector = styled.button`
  ${({ theme }) => theme.fonts.PRI_HDR_BLK};
  font-size: ${({ theme }) => theme.FontSize.MED10};
  line-height: ${({ theme }) => theme.FontSize.MED10};
  text-align: center;
  margin: 15px;
  padding: 20px;
  min-width: 125px;
  border-radius: 30px;
  cursor: pointer;

  &:hover, &:focus {
    color: ${({ colorProfile }) => themeUtil(Prop.BTN_TXT_ACTIVE, CPNT, colorProfile)};
    background-color: ${({ colorProfile }) => themeUtil(Prop.BTN_BG_ACTIVE, CPNT, colorProfile)};
  }

  &:focus {
    outline: 2px solid ${({ colorProfile }) => themeUtil(Prop.BTN_BG_ACTIVE, CPNT, colorProfile)};
    outline-offset: 2px;
  }

  ${({ active, colorProfile }) => ((active) ? `
    color: ${themeUtil(Prop.BTN_TXT_ACTIVE, CPNT, colorProfile)};
    background-color: ${themeUtil(Prop.BTN_BG_ACTIVE, CPNT, colorProfile)};
  ` : `
    color: ${themeUtil(Prop.BTN_TXT, CPNT, colorProfile)};
    background-color: ${themeUtil(Prop.BTN_BG, CPNT, colorProfile)};
  `)}
`;

export const ActiveHotspotImageContainer = styled.div``;
